import * as React from "react";
const SvgArrowTriangleUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "currentColor", stroke: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M32,16l24,24h-48z" }));
export default SvgArrowTriangleUp;
